import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchBusinessGroupsTypes = getApiActionTypes('TOOLS/FETCH_BUSINESS_GROUPS');
export const fetchEntitiesTypes = getApiActionTypes('TOOLS/FETCH_ENTITIES');
export const refreshDcsPcsTypes = getApiActionTypes('TOOLS/REFRESH_DCS_PCS');
export const RESET_ENTITIES = 'TOOLS/RESET_ENTITIES';
